import { createFileRoute } from '@tanstack/react-router';
import UpdatePasswordForm from '~/components/Auth/UpdatePasswordForm/UpdatePasswordForm';

export const Route = createFileRoute('/_public/update-password')({
  component: UpdatePasswordForm,
});
